export default class HeaderSearch {
    constructor() {
        this.fetchDomElements();
        this.registerEventListeners();
    }

    fetchDomElements() {
        this.domElements = {
            searchToggleBtn: document.getElementById('toggleSearchBtn'),
            mobileSearchToggleBtn: document.getElementById('mobileToggleSearchBtn'),
            selectionAndSearchContainer: document.getElementById('selectionAndSearchContainer'),
            navToggleBtn: document.querySelectorAll('.menu-col .navbar-toggler'),
            loginToggleBtns: document.querySelectorAll('.loginToggleBtn'),
            toggleMinibasketBtns: document.querySelectorAll('.toggleMinibasketBtn'),
            searchInput: document.getElementById('searchParam'),
            mobileSearchInput: document.getElementById('mobileSearchParam'),
            mobileSearchForm: document.getElementById('mobileSearchForm'),
        };
    }

    registerEventListeners() {
        this.domElements.searchToggleBtn.addEventListener('click', () => this.onSearchToggleBtnClick());
        if (this.domElements.mobileSearchToggleBtn) {
            this.domElements.mobileSearchToggleBtn.addEventListener('click', () => this.onMobileSearchToggleBtnClick());
        }
    }

    onMobileSearchToggleBtnClick() {
        if (this.domElements.mobileSearchToggleBtn.classList.contains('searchOpen')) {
            if (this.domElements.mobileSearchInput.value.length == 0) {
                this.domElements.mobileSearchToggleBtn.classList.remove('searchOpen');
                this.domElements.mobileSearchForm.classList.remove('open');
            } else {
                document.getElementById('mobileSearchForm').submit();
            }
        } else {
            this.domElements.mobileSearchToggleBtn.classList.add('searchOpen');
            this.domElements.mobileSearchForm.classList.add('open');
            this.domElements.mobileSearchInput.focus();
        }
    }

    onSearchToggleBtnClick() {
        if (document.body.classList.contains('searchOpen')) {
            if (this.domElements.searchInput.value.length == 0) {
                this.close();
            } else {
                document.getElementById('searchForm').submit();
            }
        } else {
            this.open();
        }
    }

    close() {
        this.domElements.selectionAndSearchContainer.classList.remove('open');
        document.body.classList.remove('searchOpen');
    }

    open() {
        this.closeOtherLayers();

        this.domElements.selectionAndSearchContainer.classList.add('open');
        document.body.classList.add('searchOpen');

        this.domElements.searchInput.focus();
    }

    closeOtherLayers() {
        if (document.body.classList.contains('loginOpen')) {
            this.domElements.loginToggleBtns[0].click();
        }

        if (document.body.classList.contains('menuOpen')) {
            this.domElements.navToggleBtn[0].click();
        }

        if (document.body.classList.contains('minibasketOpen')) {
            this.domElements.toggleMinibasketBtns[0].click();
        }
    }
}
